module.exports = __webpack_public_path__ + "img/product.ac13d947.svg";